"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormContent = exports.fetchPageContent = void 0;
const react_query_1 = require("@tanstack/react-query");
const types_1 = require("../../types/index.js");
const constants_1 = require("../../constants/index.js");
const fetchPageContent = ({ queryKey, }) => __awaiter(void 0, void 0, void 0, function* () {
    const pageId = queryKey[1];
    return fetch(`${constants_1.PAGE_CONTENT_URL}/${pageId}/`).then((res) => res.json());
});
exports.fetchPageContent = fetchPageContent;
const useFormContent = (pageId) => {
    if (!pageId) {
        return { formContentData: undefined, hasErrorOnFormContent: false, isFormContentLoading: false };
    }
    const { data: formContentData, isError: hasErrorOnFormContent, isLoading: isFormContentLoading, isSuccess: isFormContentSuccess, isFetching: isFormContentFetching, } = (0, react_query_1.useQuery)([types_1.QueryKeys.FORM_CONTENT, pageId], exports.fetchPageContent, {
        retry: false,
        refetchOnWindowFocus: false,
    });
    return {
        formContentData,
        isFormContentFetching,
        hasErrorOnFormContent,
        isFormContentLoading,
        isFormContentSuccess,
    };
};
exports.useFormContent = useFormContent;
